'use strict';

/**
 * Controller for managing media browser functionality in the CMS
 */
class EAssessmentMediaBrowserDirectiveControllerCk5 {
    /*@ngInject*/
    constructor(TaskDataService, LogBridgeService, $scope, $rootScope, $attrs, TaskInfoService, 
                $translate, $bridges, $routeParams, $signals, $timeout, $uibModal, APIService, 
                $sce, CMSMediaInfoService, FindObjectService, $filter, $q) {
        
        // Store services
        this.TaskDataService = TaskDataService;
        this.LogBridgeService = LogBridgeService;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$attrs = $attrs;
        this.TaskInfoService = TaskInfoService;
        this.$translate = $translate;
        this.$bridges = $bridges;
        this.$routeParams = $routeParams;
        this.$signals = $signals;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.APIService = APIService;
        this.$sce = $sce;
        this.CMSMediaInfoService = CMSMediaInfoService;
        this.FindObjectService = FindObjectService;
        this.$filter = $filter;
        this.$q = $q;

        // Bind modal controllers
        this.editModalInstanceController = this.editModalInstanceController.bind(this);
        this.deleteModalInstanceController = this.deleteModalInstanceController.bind(this);
        this.replaceModalInstanceController = this.replaceModalInstanceController.bind(this);
        this.onMultipleDeleteResultInstanceController = this.onMultipleDeleteResultInstanceController.bind(this);

        // Initialize controller properties
        this.mediaFilterType = '';
        this.mediaMultipleDeleteList = [];
        this.mediaList = [];
        this.standalone = true; // Default-Wert
        this.showfilter = false; // Default-Wert
        
        // Initialize controller
        this.init();
    }

    /**
     * Initialize the controller
     */
    init() {
        // Set up logging
        this.$scope._logIdentifier = 'EAssessmentMediaBrowserControllerCk5';
        this.$logger = this.$bridges.logger();
        this.$logger.logEnter(this.$scope, 'init' + this.$scope._logIdentifier);

        // Initialize variables
        this._defer = null;
        this.taskContext = this.TaskDataService.fetchContext();
        this.mediaListDone = false;
        
        // Set scope variables
        this.$scope.currentEditorId = this.$rootScope.currentEditorId;
        this.$scope.currentAreaId = this.$rootScope.currentAreaId;
        
        if (angular.isUndefined(this.$scope.taskTitle)) {
            this.$scope.taskTitle = this.$translate.instant('CMS.MEDIA-MANAGER.TITLE', { 
                s1: this.TaskInfoService.getTaskInfo().getTitle() 
            });
        }

        this.$scope.taskuuid = this.$routeParams.taskUUID;

        // Set up media filtering
        this.$scope.mediaFilterType = 'image';
        this.$scope.mediaFilterTypeExtended = undefined;
        
        // Initialize multiple delete functionality
        this.$scope.mediaMultipleDeleteList = [];

        // Set up scope methods
        this.setupScopeMethods();

        // Load initial media list
        if (!this.mediaListDone) {
            this.mediaList = this.getMediaList();
            console.log('mediaList ==>', this.mediaList);
            this.mediaListDone = true;
        }

        // Set up signal handlers
        this.setupSignalHandlers();

        // Setup additional functionality
        this.setupDragAndDrop();
        this.setupAttributes();
    }

    /**
     * Set up methods on the scope
     */
    setupScopeMethods() {
        this.$scope.setMediaFilterType = (value) => this.$scope.mediaFilterType = value;
        
        this.$scope.onChangeIncludeTranslation = (media) => this.onChangeIncludeTranslation(media);
        this.$scope.onChangeIncludeForCandidate = (media) => this.onChangeIncludeForCandidate(media);
        
        this.$scope.onDeleteCheckboxClick = (media) => this.onDeleteCheckboxClick(media);
        this.$scope.onMultipleDeleteCancelButtonClick = () => this.onMultipleDeleteCancelButtonClick();
        this.$scope.onMultipleDeleteButtonClick = () => this.onMultipleDeleteButtonClick();
        
        this.$scope.onEditButtonClick = (uuid) => this.onEditButtonClick(uuid);
        this.$scope.onDeleteButtonClick = (uuid) => this.onDeleteButtonClick(uuid);
        this.$scope.onMediaClick = (uuid, media) => this.onMediaClick(uuid, media);

        this.$scope.getMediaObjectURL = (mediaObject) => this.getMediaObjectURL(mediaObject);
        this.$scope.onDropCallback = (event, ui) => this.onDropCallback(event, ui);
    }

    /**
     * Set up signal handlers
     */
    setupSignalHandlers() {
        this.$signals.remove(IB.Signals.REPOSITORY_ADD_FILE_AND_REFRESH);
        this.$signals.on(IB.Signals.REPOSITORY_ADD_FILE_AND_REFRESH, (data) => {
            if (typeof data.result !== 'undefined') {
                this.$scope.$apply(() => {
                    const uuid = data.result['uuid'];
                    delete data.result['uuid'];
                    this.taskContext.write(uuid, data.result);
                    if (angular.isFunction(this.$bridges.data().put)) {
                        this.$bridges.data().put(null, null, data.result);
                    }
                });
            } else {
                this.$scope.$apply(() => {
                    const uuid = data['uuid'];
                    delete data['uuid'];
                    this.taskContext.write(uuid, data);
                    if (angular.isFunction(this.$bridges.data().put)) {
                        this.$bridges.data().put(null, null, data);
                    }
                });
            }
        });

        this.$signals.remove(IB.Signals.REPOSITORY_MEDIALIST_CHANGE);
        this.$signals.on(IB.Signals.REPOSITORY_MEDIALIST_CHANGE, () => {
            this.$timeout(() => {
                this.$scope.$apply(() => {
                    this.$scope.mediaList = this.getMediaList();
                });
            }, 1);
        });

        this.$signals.remove(IB.Signals.REPOSITORY_UPDATE_OBJECT);
        this.$signals.on(IB.Signals.REPOSITORY_UPDATE_OBJECT, (uuid, obj) => {
            this.taskContext.update(uuid, obj).save();
        });
    }

    /**
     * Draggable options configuration
     */
    setupDragAndDrop() {
        this.$scope.dndOptions = {
            revert: true,
            tolerance: 'intersect'
            //handle: '.media-browser-move' // This can be used to restrict drag&drop of the card to the drag handle icon only
        };
    }

    /**
     * Initialize attributes from HTML tags
     */
    setupAttributes() {
        // Show filter
        this.$scope.showfilter = false;
        if (this.$attrs.showfilter) {
            this.$timeout(() => {
                this.$scope.$apply(() => {
                    this.$scope.showfilter = this.$scope.$eval(this.$attrs.showfilter);
                });
            }, 1);
        }

        // Standalone mode
        this.$scope.standalone = true;
        if (this.$attrs.standalone) {
            this.$timeout(() => {
                this.$scope.$apply(() => {
                    this.$scope.standalone = this.$scope.$eval(this.$attrs.standalone);
                });
            }, 1);
        }

        // Current media UUID
        this.$scope.currentmediauuid = undefined;
        if (typeof(this.$attrs.currentmediauuid) !== "undefined") {
            this.$timeout(() => {
                this.$scope.$apply(() => {
                    this.$scope.currentmediauuid = this.$attrs.currentmediauuid;
                });
            });
        }

        // Content object UUID
        this.$scope.contentobjectuuid = undefined;
        if (this.$attrs.contentobjectuuid) {
            this.$timeout(() => {
                this.$scope.$apply(() => {
                    this.$scope.contentobjectuuid = this.$attrs.contentobjectuuid;
                });
            });
        }

        // Show only specific media type
        if (typeof(this.$attrs.showonly) !== "undefined") {
            this.$timeout(() => {
                const _allowed = /^(image|video|audio|subtitle|measurementobject|universalcanvas|iframe|geogebra)$/;
                if (_allowed.test(this.$attrs.showonly)) {
                    if (this.$attrs.showonly == 'measurementobject') {
                        this.$scope.mediaFilterType = 'image';
                        this.$scope.mediaFilterTypeExtended = this.$attrs.showonly;
                    } else {
                        this.$scope.mediaFilterType = this.$attrs.showonly;
                    }
                }
            }, 1);
        }
    }

    /**
     * Add a cache-busting hash to URLs
     * @returns {string} Cache busting query parameter
     */
    addNoCacheHash() {
        return '?' + Math.floor((Math.random()*1000000000001));
    }

    /**
     * Get the list of media objects
     * @returns {Array} List of media objects
     */
    getMediaList() {
        const objs = this.taskContext.findInstancesByType('media');
        const objList = [];
        
        for (const key in objs) {
            if (objs.hasOwnProperty(key)) {
                const media = objs[key];
                console.log('media List ==>', media.getForUseOfCandidate());

                let forUseOfCandidate = media.getForUseOfCandidate();
                if (!Array.isArray(forUseOfCandidate)) {
                    forUseOfCandidate = [];
                }
                media.isForUseOfCandidate = forUseOfCandidate.includes(this.$scope.currentAreaId);

                const mediaObj = {
                    uuid: key,
                    name: key + '.' + media.getFileExtension(),
                    originalname: media.getUploadName(),
                    ellipsisname: media.getUploadName().length <= 40 ? 
                        media.getUploadName() : 
                        this.$filter('ellipsis')(media.getUploadName(), 40),
                    size: angular.bytesToSize(media.getFileSize()),
                    bytes: media.getFileSize(),
                    type: media.getFileType(),
                    mimetype: media.getMimeType(),
                    thumbnail: media.getThumbnailURL(this.$scope.taskuuid) + this.addNoCacheHash(),
                    comments: media.getComments(),
                    height: media.getHeight(),
                    width: media.getWidth(),
                    isIncludeTranslation: media.isIncludeTranslation(),
                    isForUseOfCandidate: media.isForUseOfCandidate,
                    hasReferences: this.mediaHasBeenReferenced(key),
                    references: this.$sce.trustAsHtml(this.getMediaReferences(key)).toString(),
                    deletionMark: false,
                };

                if (isCMS && !this.$rootScope.isPreview) {
                    objList.push(mediaObj);
                } else if (media.isForUseOfCandidate) {
                    objList.push(mediaObj);
                }
            }
        }

        return objList;
    }

    /**
     * Check if media has been referenced anywhere
     * @param {string} mediaUUID Media UUID to check
     * @returns {boolean} Whether media is referenced
     */
    mediaHasBeenReferenced(mediaUUID) {
        const inOverview = this.FindObjectService.locateMediaInOverview(mediaUUID);
        const inPalettes = this.FindObjectService.locateMediaInPalettes(mediaUUID);
        const inQuestions = this.FindObjectService.locateMedia(mediaUUID);
        const inIframeToolIcon = this.FindObjectService.locateMediaAsIconOfIframeTool(mediaUUID);
        const inIframeTool = this.FindObjectService.getMediaReferencedInIframeTool()[mediaUUID] || false;
        const inVideoSubtitle = this.FindObjectService.locateMediaAsVideoSubtitle(mediaUUID);
        const inAudioBackground = this.FindObjectService.locateMediaAsAudioBackground(mediaUUID);

        return Boolean(inOverview || inPalettes || inQuestions || inIframeToolIcon || 
                      inIframeTool || inVideoSubtitle || inAudioBackground);
    }

    /**
     * Get human readable list of questions
     * @param {Array} questions Array of questions
     * @returns {string} Human readable list
     */
    getQuestionList(questions) {
        if (!questions.length) return '';
        return angular.humanReadableList(Object.keys(questions).map(
            function(idx) {
                return questions[idx].shortTitle
            }).sort());
    }

    /**
     * Check if array contains human readable values
     */
    isHumanReadable(arr, fieldName) {
        if (!arr.length) return false;
        return arr.reduce(function(a, b) {
            var tmp = {},
                a_bool = "undefined" != typeof a[fieldName] && a[fieldName] ? true : false,
                b_bool = "undefined" != typeof b[fieldName] && b[fieldName] ? true : false;
            tmp[fieldName] = (a_bool && b_bool);
            return tmp;
        });
    }

    /**
     * Get human readable name from object
     */
    getHumanReadableName(obj, fieldName) {
        if (!obj.length) return '';
        return angular.humanReadableList(Object.keys(obj).map(
            function(idx) {
                return obj[idx][fieldName] || 'fieldname error'
            }).sort());
    }

    /**
     * Get media references HTML
     */
    getMediaReferences(mediaUUID) {
        const questions = this.FindObjectService.locateMedia(mediaUUID);
        const palettes = this.FindObjectService.locateMediaInPalettes(mediaUUID);
        const overview = this.FindObjectService.locateMediaInOverview(mediaUUID);
        const iframeIcon = this.FindObjectService.locateMediaAsIconOfIframeTool(mediaUUID);
        const iframeTool = this.FindObjectService.getMediaReferencedInIframeTool()[mediaUUID];
        const videoSubtitle = this.FindObjectService.locateMediaAsVideoSubtitle(mediaUUID);
        const audioBackground = this.FindObjectService.locateMediaAsAudioBackground(mediaUUID);
        let html = '';

        if (Boolean(overview)) {
            html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.OVERVIEW') +
                '<strong>' +
                this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.IN-OVERVIEW') +
                '</strong>.<br>';
        }

        if (Boolean(questions)) {
            html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.QUESTIONS') +
                '<span class="referenced-media">' +
                ' ' +
                this.getHumanReadableName(questions, 'shortTitle') +
                '</span>.<br>';
        }

        if (Boolean(palettes)) {
            html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.PALETTES') +
                '<span class="referenced-media">' +
                ' ' +
                this.getHumanReadableName(palettes, 'name') +
                '</span>.';
        }

        if (Boolean(iframeTool)) {
            html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.IFRAME-TOOL') +
                '<span class="referenced-media">' +
                ' ' +
                this.getHumanReadableName(iframeTool, 'description') +
                '</span>.';
        }

        if (Boolean(iframeIcon)) {
            html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.IFRAME-ICON') +
                '<span class="referenced-media">' +
                ' ' +
                this.getHumanReadableName(iframeIcon, 'name') +
                '</span>.';
        }

        if (Boolean(videoSubtitle)) {
            if (videoSubtitle.length) {
                let _videos = [], _questions = [];
                for (let sub in videoSubtitle) {
                    if (videoSubtitle[sub].videoName) {
                        _videos.push(videoSubtitle[sub]);
                    } else if (videoSubtitle[sub].question.shortTitle) {
                        _questions.push(videoSubtitle[sub].question)
                    }
                }

                if (_videos.length) {
                    html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.VIDEO-SUBTITLE') +
                        '<span class="referenced-media">' +
                        ' ' +
                        this.getHumanReadableName(_videos, 'videoName') +
                        '</span><br>';
                }
                if (_questions.length) {
                    html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.QUESTIONS') +
                        '<span class="referenced-media">' +
                        ' ' +
                        this.getHumanReadableName(_questions, 'shortTitle') +
                        '</span>';
                }
            }
        }

        if (Boolean(audioBackground)) {
            if (audioBackground.length) {
                let _audios = [], _questionsAudio = [];
                for (let cont in audioBackground) {
                    if (audioBackground[cont].audioName) {
                        _audios.push(audioBackground[cont]);
                    } else if (audioBackground[cont].question.shortTitle) {
                        _questionsAudio.push(audioBackground[cont].question)
                    }
                }

                if (_audios.length) {
                    html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.AUDIO-BACKGROUND') +
                        '<span class="referenced-media">' +
                        ' ' +
                        this.getHumanReadableName(_audios, 'audioName') +
                        '</span><br>';
                }
                if (_questionsAudio.length) {
                    html += this.$translate.instant('CMS.MEDIA-MANAGER.BROWSER.REFERENCES.QUESTIONS') +
                        '<span class="referenced-media">' +
                        ' ' +
                        this.getHumanReadableName(_questionsAudio, 'shortTitle') +
                        '</span>';
                }
            }
        }
        return html;
    }

    /**
     * Get media object by UUID
     */
    getMediaObject(wantedUUID) {
        let _result;
        for (let key in this.$scope.mediaList) {
            if (wantedUUID == this.$scope.mediaList[key].uuid) {
                _result = this.$scope.mediaList[key];
                break;
            }
        }
        return _result;
    }

    /**
     * Handle media click
     */
    onMediaClick(selectedMediaUUID, selectedMedia) {
        const selectedmedia = {
            'uuid': selectedMediaUUID,
            'contentobjectuuid': this.$scope.currentAreaId.replace(/_ck5$/, ''),
            'url': this.getMediaURL(selectedMedia),
            'base64': this.taskContext.read(selectedMediaUUID).getBase64(this.$scope.taskuuid)
        };
        this.$signals.emit('mediaSelected', selectedmedia, this.$scope.currentEditorId);
        this.CMSMediaInfoService.clearCache();
    }

    /**
     * Get media URL
     */
    getMediaURL(mediaObject, thumbnail) {
        const thumbnailSlug = '_thumb';
        const thumbnailExtension = 'jpg';

        if (!angular.isObject(mediaObject)) {
            return false;
        }

        thumbnail = angular.isDefined(thumbnail) ? thumbnail : false;
        const re = /(?:\.([^.]+))?$/;
        const uploadName = mediaObject.originalname;
        const extension = thumbnail ? thumbnailExtension : re.exec(uploadName)[1];
        const mimeType = mediaObject.mimeType;
        const fileNameSlug = thumbnail ? thumbnailSlug : "";
        let fileName = mediaObject.uuid + fileNameSlug + '.' + extension;

        if (mimeType == 'image/svg+xml') {
            fileName = mediaObject.uuid + fileNameSlug + '.svg';
        }

        const url = isCMS ? "/media/" + this.$scope.taskuuid + "/" + fileName : "/media/" + fileName;

        return url;
    }

    /**
     * Handle multiple delete checkbox click
     */
    onDeleteCheckboxClick(media) {
        media.deletionMark = !media.deletionMark;
        if (media.deletionMark) {
            this.$scope.mediaMultipleDeleteList.push(media.uuid);
        } else {
            this.removeMediaFromMultipleDeleteList(media.uuid);
        }
    }

    /**
     * Remove media from multiple delete list
     */
    removeMediaFromMultipleDeleteList(mediaUUID) {
        if (!mediaUUID) {
            return;
        }

        const l = this.$scope.mediaMultipleDeleteList.length;
        if (l) {
            for (let i = l - 1; i >= 0; i--) {
                if (mediaUUID === this.$scope.mediaMultipleDeleteList[i]) {
                    this.$scope.mediaMultipleDeleteList.splice(i, 1);
                    return;
                }
            }
        }
    }

    /**
     * Cancel multiple delete operation
     */
    onMultipleDeleteCancelButtonClick() {
        angular.forEach(this.$scope.mediaList, (obj) => {
            obj.deletionMark = false;
        });
        this.$scope.mediaMultipleDeleteList = [];
    }

    /**
     * Handle multiple delete button click
     */
    onMultipleDeleteButtonClick() {
        const l = this.$scope.mediaMultipleDeleteList.length;
        if (l) {
            for (let i = l - 1; i >= 0; i--) {
                const mediaObj = this.getMediaObject(this.$scope.mediaMultipleDeleteList[i]);
                if(angular.isUUID(mediaObj.uuid)){
                    if (!mediaObj.hasReferences) {
                        this.deleteSingleMediaObject(angular.copy(mediaObj.uuid), false);
                    } else {
                        mediaObj.deletionMark = false;
                    }
                }
            }
        }
        this.commitChanges();
    }

    /**
     * Commit changes to store
     */
    commitChanges() {
        this._defer = this.$q.defer();
        this.$scope.mediaBrowserPromise = this._defer.promise;

        if (angular.isFunction(this.$bridges.data().commitStore)) {
            this.$bridges.data().commitStore((success_, err) => {
                if (success_) {
                    this.$timeout(() => {
                        this.$signals.emit(IB.Signals.REPOSITORY_MEDIALIST_CHANGE);
                        if (this.$scope.mediaMultipleDeleteList.length) {
                            this.onMultipleDeleteResult();
                            this.onMultipleDeleteCancelButtonClick();
                        }
                    }, 1000);
                    this._defer.resolve();
                } else {
                    this._defer.reject();
                }
            });
        } else {
            console.error('commitStore is not a function. Cannot commit changes!');
        }
    }

    /**
     * Delete a single media object
     */
    deleteSingleMediaObject(uuid, doCommit) {
        this.$bridges.data().remove(uuid);
        this.removeMediaFromMultipleDeleteList(uuid);

        if (doCommit) {
            this.commitChanges();
        }
    }

    /**
     * Handle include translation change
     */
    onChangeIncludeTranslation(media) {
        const mediaObject = _.find(this.taskContext.findInstancesByType('media'), (obj) => {
            return obj.getUUID() === media.uuid;
        });
        mediaObject.data.includeTranslation = media.isIncludeTranslation;
        this.taskContext.update(media.uuid, mediaObject.data);
        if (angular.isFunction(this.$bridges.data().put)) {
            this.$bridges.data().put(null, null, mediaObject.data);
        }
        this.commitChanges();
    }

    /**
     * Handle include for candidate change
     */
    onChangeIncludeForCandidate(media) {
        const mediaObject = _.find(this.taskContext.findInstancesByType('media'), (obj) => {
            return obj.getUUID() === media.uuid;
        });

        if (!Array.isArray(mediaObject.data.forUseOfCandidate)) {
            mediaObject.data.forUseOfCandidate = [];
        }

        const index = mediaObject.data.forUseOfCandidate.indexOf(this.$scope.currentAreaId);
        if (index === -1) {
            mediaObject.data.forUseOfCandidate.push(this.$scope.currentAreaId);
        } else {
            mediaObject.data.forUseOfCandidate.splice(index, 1);
        }

        this.taskContext.update(media.uuid, mediaObject.data);
        if (angular.isFunction(this.$bridges.data().put)) {
            this.$bridges.data().put(null, null, mediaObject.data);
        }

        this.commitChanges();
    }

    /**
     * Show edit modal
     */
    onEditButtonClick(uuid) {
        this.$scope.mediaComments = undefined;
        const modalInstance = this.$uibModal.open({
            templateUrl: '/views/ib/cms/eassessment/eassessmentmediamodaledit.html',
            controller: this.editModalInstanceController,
            resolve: {
                mediaObject: () => this.getMediaObject(uuid),
                taskuuid: () => this.$scope.taskuuid,
                taskContext: () => this.taskContext
            }
        });
    }

    /**
     * Controller for edit modal
     */
    editModalInstanceController($scope, $uibModalInstance, mediaObject, taskuuid, $sce, taskContext) {
        $scope.taskuuid = taskuuid;
        $scope.mediaObject = mediaObject;
        $scope.thumbnail = '_thumb.jpg';

        switch(mediaObject.type) {
            case "audio":
                $scope.mediaObjectUrl = taskContext.read(mediaObject.uuid);
                $scope.imageUrl = '/media/' + taskuuid + '/' + mediaObject.thumbnail + '/';
                break;
            case "video":
                $scope.mediaObjectUrl = $sce.trustAsResourceUrl(taskuuid + '/' + mediaObject.uuid);
                break;
            case "image":
                $scope.mediaObjectUrl = '/media/' + taskuuid + '/' + mediaObject.name + '/';
                break;
            case "subtitle":
                $scope.mediaObjectUrl = mediaObject.thumbnail;
                break;
            case "iframe":
                $scope.iframeUrl = "/iframe/"+taskuuid+"/"+mediaObject.uuid+"/";
                break;
        }

        $scope.editModal = {};
        $scope.editModal.comments = mediaObject.comments || '';

        $scope.onModalCloseButtonClick = () => {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onModalSaveChangesButtonClick = () => {
            const _response = {
                'comments': $scope.editModal.comments,
            };

            this.$signals.emit(IB.Signals.REPOSITORY_UPDATE_OBJECT, $scope.mediaObject.uuid, _response);
            this.$signals.emit(IB.Signals.REPOSITORY_MEDIALIST_CHANGE);
            this.$logger.info(this._logIdentifier, 'media object has been updated');
            $uibModalInstance.close();
        };
    }

    /**
     * Show delete confirmation modal
     */
    onDeleteButtonClick(uuid) {
        const modalInstance = this.$uibModal.open({
            templateUrl: '/views/ib/cms/eassessment/eassessmentmediamodalconfirmation.html',
            size: 'sm',
            controller: this.deleteModalInstanceController,
            resolve: {
                mediaObject: () => this.getMediaObject(uuid),
                taskuuid: () => this.$scope.taskuuid
            }
        });
    }

    /**
     * Controller for delete confirmation modal
     */
    deleteModalInstanceController($scope, $uibModalInstance, mediaObject, taskuuid) {
        $scope.mediaObject = mediaObject;
        $scope.taskuuid = taskuuid;
        $scope.mediaObject.ellipsis = this.$filter('ellipsis')($scope.mediaObject.originalname, 25);

        $scope.onModalCloseButtonClick = () => {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onModalDeleteConfirmationButtonClick = () => {
            if ($scope.mediaObject.hasReferences) {
                $uibModalInstance.close();
                return true;
            }

            this.deleteSingleMediaObject(angular.copy($scope.mediaObject.uuid), true);
            $uibModalInstance.close();
        };
    }

    /**
     * Show multiple delete result modal
     */
    onMultipleDeleteResult() {
        const modalInstance = this.$uibModal.open({
            templateUrl: '/views/ib/cms/eassessment/modal/eassessmentmediadeleteresultModal.html',
            controller: this.onMultipleDeleteResultInstanceController,
            resolve: {
                nonDeletedFiles: () => {
                    const _l = [];
                    angular.forEach(this.$scope.mediaMultipleDeleteList, (uuid) => {
                        _l.push(this.getMediaObject(uuid));
                    });
                    return _l;
                }
            }
        });
    }

    /**
     * Controller for multiple delete result modal
     */
    onMultipleDeleteResultInstanceController($scope, $uibModalInstance, nonDeletedFiles) {
        $scope.nonDeletedFiles = nonDeletedFiles;
        
        $scope.onModalCloseButtonClick = () => {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /**
     * Get URL for media object
     */
    getMediaObjectURL(mediaObject) {
        if (!angular.isObject(mediaObject)) {
            return false;
        }

        const thumbnailSlug = '_thumb';
        const thumbnailExtension = 'ggb';
        const thumbnail = false;

        try {
            const re = /(?:\.([^.]+))?$/;
            const uploadName = mediaObject.originalname || '';
            const extension = thumbnail ? thumbnailExtension : (re.exec(uploadName)[1] || 'unknown');
            const fileNameSlug = thumbnail ? thumbnailSlug : "";
            const fileName = mediaObject.uuid + fileNameSlug + '.' + extension;

            return isCMS ? "/media/" + this.$scope.taskuuid + "/" + fileName : "/media/" + fileName;
        } catch (error) {
            console.error('Error generating media URL:', error);
            return false;
        }
    }

    /**
     * Handle drop callback for drag & drop
     */
    onDropCallback(event, ui) {
        const source = ui.helper.context.id;
        const target = event.target.id;
        this.onReplaceMedia(source, target);
    }

    /**
     * Show replace media modal
     */
    onReplaceMedia(sourceUUID, targetUUID) {
        const modalInstance = this.$uibModal.open({
            templateUrl: '/views/ib/cms/eassessment/eassessmentmediamodalreplace.html',
            controller: this.replaceModalInstanceController,
            resolve: {
                mediaSource: () => this.getMediaObject(sourceUUID),
                mediaTarget: () => this.getMediaObject(targetUUID),
                taskuuid: () => this.$scope.taskuuid
            }
        });
    }

    /**
     * Controller for replace media modal
     */
    replaceModalInstanceController($scope, $uibModalInstance, mediaSource, mediaTarget, taskuuid) {
        $scope.mediaSource = mediaSource;
        $scope.mediaTarget = mediaTarget;

        $scope.mediaSource.ellipsis = this.$filter('ellipsis')($scope.mediaSource.originalname, 30);
        $scope.mediaTarget.ellipsis = this.$filter('ellipsis')($scope.mediaTarget.originalname, 30);

        $scope.taskuuid = taskuuid;
        $scope.replaceModal = {};

        $scope.onModalCloseButtonClick = () => {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onModalReplaceConfirmationButtonClick = () => {
            this.APIService
                .renameEntity(
                    taskuuid,
                    $scope.mediaSource.uuid,
                    $scope.mediaTarget.uuid
                )
                .then((response) => {
                    this.taskContext.remove($scope.mediaSource.uuid);
                    this.taskContext.remove($scope.mediaTarget.uuid);
                    this.taskContext.write(response.data.objects.source.uuid, response.data.objects.source);
                    this.$signals.emit(IB.Signals.REPOSITORY_MEDIALIST_CHANGE);
                })
                .then(() => {
                    this.$signals.emit(IB.Signals.REPOSITORY_MEDIALIST_CHANGE);
                });

            $uibModalInstance.close();
            return false;
        };
    }
}

export default EAssessmentMediaBrowserDirectiveControllerCk5;

